import React from 'react';
import { useNavigate } from 'react-router-dom';

export const GroupListHeaderActions = () => {
    const navigate = useNavigate();

    return (
        <div className="page-header-right ms-auto">
            <div className="page-header-right-items">
                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                    <button type="button" className="btn btn-primary" onClick={() => navigate('/group/create')}>
                        <i className="feather-plus me-2"></i>
                        <span>Nuevo</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
